import { Pipe, PipeTransform } from '@angular/core';

import { IBomModel } from '../../prisma-xs/models/bom.model';
import {
  collateQuantitiesBom,
  filterModelsBasedOnSelectedEnclosures
} from '../../prisma-xs/helpers/bom-mapper.helper';

@Pipe({
    name: 'countNumberOfPositionsBOM',
    standalone: false
})
export class CountNumberOfPositionsBOMPipe implements PipeTransform {

  // eslint-disable-next-line max-len
  transform(selectedBom: number[], bomModels: IBomModel[], bomModelsAccessories: IBomModel[], selectedDevicesAccessories: number[], bomProjectAccessories?: IBomModel[], selectedProjectAccessories?: number[], selectedEnclosures?: number[]): number {

    const bomTable = filterModelsBasedOnSelectedEnclosures(bomModels, selectedEnclosures)
      .filter(m => selectedBom.includes(m.article.id));

    const accessoriesTable = filterModelsBasedOnSelectedEnclosures(bomModelsAccessories, selectedEnclosures)
      .filter(m => selectedDevicesAccessories.includes(m.article.id));

    const projectAccessoriesTable = this.countIncludedDevices(bomProjectAccessories, selectedProjectAccessories);

    return collateQuantitiesBom(collateQuantitiesBom(bomTable, accessoriesTable), projectAccessoriesTable)?.length;
  }

  private countIncludedDevices(articles: IBomModel[], selected: number[]): IBomModel[] {
    return articles?.filter(b => selected.includes(b.article.id)) || [];
  }

}
